import React, { useCallback, useEffect, useState } from 'react'
import { Route, RouteProps, RouteComponentProps } from 'react-router-dom'
import { pathNames, KeyNotice, SourceRoute } from './router'
// import { keyNameSessionStorage, getSessionStorage, removeSessionStorage } from '../utils/localStorage'
import { keyNameSessionStorage, getSessionStorage, removeSessionStorage } from '../utils/sessionStorage'
import jwt from 'jsonwebtoken'
import { observable } from 'mobx'
import { task } from 'mobx-task'
import apiUrl from '../configs/apiUrl'
import { CommunityResponse, ParamCommunity } from '../pages/community/CommunityList'
import { axiosPost } from '../utils/axios'
import useStore from '../stores/useStore'
import { observer } from 'mobx-react-lite'

// import { getCookie } from '../utils/cookie'

type ReturnTypeUsePrivateRouteAdmin = ReturnType<typeof usePrivateRouteAdmin>
type UsePrivateRouteAdmin = { routes: SourceRoute[] } & RouteProps
const usePrivateRouteAdmin = ({ location, routes, ...props }: UsePrivateRouteAdmin) => {
    const { notificationMenuStore } = useStore()
    const authPathObj = routes?.find((route) => route.path === location?.pathname)

    // let match = useRouteMatch(location?.pathname as string)

    const isAdminOverview = routes?.some((route) => route.path === pathNames.adminOverview)

    const [state] = useState(
        observable({
            community: [] as CommunityResponse[],
            queryCommunity: task.resolved(async (params: ParamCommunity) => {
                const methodPostCommunity = axiosPost<CommunityResponse[], ParamCommunity>({
                    url: apiUrl.getSearchCommunity,
                    params: params || {},
                    authorizationType: 'authorization',
                })
                const { data } = await methodPostCommunity.request
                return data
            }),
        }),
    )

    const setNotificationMenu = useCallback(async () => {
        if (
            location?.pathname !== pathNames.adminOverview &&
            location?.pathname !== pathNames.comparison &&
            isAdminOverview
        ) {
            const community = await state.queryCommunity({})
            notificationMenuStore.setNotificationMenu(KeyNotice.takeQuestionnaire, [
                {
                    key: KeyNotice.takeQuestionnaire,
                    // countBadge: community.filter((comm) => comm.isActiveAssessment || comm.hasDraft).length,
                    countBadge: community.length,
                },
            ])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location])

    useEffect(() => {
        setNotificationMenu()
    }, [setNotificationMenu])

    return { authPathObj }
}

type PrivateRouteAdminViewProps = {} & RouteProps & ReturnTypeUsePrivateRouteAdmin
let PrivateRouteAdminView: React.FC<PrivateRouteAdminViewProps> = ({ authPathObj, ...rest }) => {
    const accessToken = getSessionStorage(keyNameSessionStorage.accessToken) || ''
    const refreshToken = getSessionStorage(keyNameSessionStorage.refreshToken) || ''
    const jwtDecoded = jwt.decode(accessToken, { complete: true }) as {
        payload?: {
            exp?: number
            roles?: string[]
        }
    }

    return (
        <>
            {(() => {
                if (jwtDecoded?.payload?.roles?.[0] === 'ADMIN' && accessToken && refreshToken && authPathObj?.path) {
                    return (
                        <Route
                            path={authPathObj?.path}
                            {...rest}
                            render={(props: any) => {
                                const { component: Component } = authPathObj
                                return Component && <Component {...props} />
                            }}
                        />
                    )
                } else {
                    removeSessionStorage([
                        keyNameSessionStorage.user,
                        keyNameSessionStorage.accessToken,
                        keyNameSessionStorage.refreshToken,
                    ])

                    window.location.href = pathNames.signInCms as string
                    // return <Redirect to={pathNames.signInCms as string} />
                }
            })()}
        </>
    )
}

PrivateRouteAdminView = observer(PrivateRouteAdminView)
type PrivateRouteUserProps = { routes: SourceRoute[] } & Omit<
    PrivateRouteAdminViewProps,
    keyof ReturnTypeUsePrivateRouteAdmin
> &
    RouteComponentProps

let PrivateRouteAdmin: React.FC<PrivateRouteUserProps> = ({ routes, ...props }) => {
    const state = usePrivateRouteAdmin({ routes, ...props })
    return <PrivateRouteAdminView {...state} />
}
PrivateRouteAdmin = observer(PrivateRouteAdmin)

export default PrivateRouteAdmin
